import { useMemo } from "react";
import { CheckInTimeEnum } from "@b2bportal/lodging-api";
import { useI18nContext } from "@hopper-b2b/i18n";
import type { HotelDetailsSectionComponentProps } from "./HotelDetailsSection";
import { convertTo12HourFormat } from "@/utils/format";

const MAX_AMENITIES = 6;

export const useHotelDetailsSection = ({
  amenities = [],
  checkInInformation,
}: HotelDetailsSectionComponentProps) => {
  const { t } = useI18nContext();

  return useMemo(() => {
    return {
      context: {
        showCheckInTime: checkInInformation?.checkInTime != null,
        showCheckOutTime: checkInInformation?.checkOutTime != null,
        amenitiesToShow: amenities.slice(0, MAX_AMENITIES),
        amenities: amenities,
        showMoreAmenetiesLink: amenities.length > MAX_AMENITIES,
      },
      text: {
        checkInTitle: t("core-hotels.shop.checkInInformation.checkinTitle"),
        checkOutTitle: t("core-hotels.shop.checkInInformation.checkoutTitle"),
        checkInTime: checkInInformation?.checkInTime
          ? checkInInformation?.checkInTime?.CheckInTime ===
            CheckInTimeEnum.Anytime
            ? t("core-hotels.shop.checkInInformation.checkinAnytime")
            : t("core-hotels.shop.checkInInformation.checkinTime", {
                time: convertTo12HourFormat(
                  checkInInformation?.checkInTime?.checkInTimeFrom
                ),
              })
          : null,
        checkOutTime: checkInInformation?.checkOutTime
          ? t("core-hotels.shop.checkInInformation.checkoutTime", {
              time: convertTo12HourFormat(checkInInformation?.checkOutTime),
            })
          : null,
        amenitiesTitle: t("core-hotels.shop.amenities.topAmenitiesTitle"),
        moreAmenities: t("core-hotels.shop.amenities.seeAllAmenities"),
      },
    };
  }, [amenities, checkInInformation, t]);
};
